module.exports = __webpack_public_path__ + "static/img/甘肃银行@2x.7631798d.png";